import { PropsWithChildren, useEffect } from 'react';

import { useConfidence } from '@spotify-confidence/react';
import { useAuth } from '@spotify/confidence-core-react';

export function FlagContext({ children }: PropsWithChildren<{}>) {
  const { user } = useAuth();
  const confidence = useConfidence();

  useEffect(() => {
    confidence.setContext({
      ...user,
    });
  }, [user]);

  // TODO wrap children in a ConfidenceProvider.WithContext({...user}) provider
  return <>{children}</>;
}
